import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging';

// Firebase configuration from Firebase Console
// Go to: Firebase Console > Project Settings > General > Your apps > Web app
// AUDIT-076: authDomain/projectId/storageBucket now come from env so a
// staging / test Firebase project can be switched in without a code edit.
// Defaults preserve existing production behavior.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC_PLACEHOLDER_REPLACE_WITH_YOUR_API_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'crm-matat.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'crm-matat',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'crm-matat.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "PLACEHOLDER_REPLACE",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "PLACEHOLDER_REPLACE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging: Messaging | null = null;

try {
  // Check if we're in a browser environment and service workers are supported
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    messaging = getMessaging(app);
  }
} catch (error) {
  console.error('Firebase messaging initialization error:', error);
}

export { app, messaging };

// VAPID Key - Web push certificates
// Go to: Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || 'PLACEHOLDER_REPLACE_WITH_VAPID_KEY';

/**
 * Request notification permission and get FCM token
 */
export const requestNotificationPermission = async (): Promise<string | null> => {
  try {
    if (!messaging) {
      console.warn('Firebase messaging not initialized');
      return null;
    }

    // Check if VAPID key is configured
    if (!VAPID_KEY || VAPID_KEY.includes('PLACEHOLDER')) {
      // Silently skip if Firebase is not configured
      return null;
    }

    // Request notification permission
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      // Get FCM token
      const token = await getToken(messaging, {
        vapidKey: VAPID_KEY
      });

      return token;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

/**
 * Listen for foreground messages
 */
export const onMessageListener = () => {
  return new Promise((resolve) => {
    if (!messaging) {
      console.warn('Firebase messaging not initialized');
      return;
    }

    onMessage(messaging, (payload) => {
      console.log('Foreground message received:', payload);
      resolve(payload);
    });
  });
};
